import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { QrCode, Loader2 } from "lucide-react";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { useAuth } from "../../context/AuthContext";
import { useToast } from "../../hooks/use-toast";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const { toast } = useToast();
  const [form, setForm] = useState({ name: "", company_name: "", email: "", password: "" });
  const [loading, setLoading] = useState(false);
  const set = (k, v) => setForm((p) => ({ ...p, [k]: v }));

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await register(form);
      navigate("/app");
    } catch (err) {
      toast({ title: "Registrazione non riuscita", description: err?.response?.data?.detail || "Riprova", variant: "destructive" });
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2">
      <div className="hidden lg:flex flex-col justify-between p-12 bg-secondary text-white relative overflow-hidden">
        <div className="absolute inset-0 opacity-30" style={{ background: "radial-gradient(60% 70% at 30% 20%, rgba(16,222,185,0.5), transparent 60%)" }} />
        <Link to="/" className="relative flex items-center gap-2.5">
          <img src="/qora-symbol.png" alt="Qora" className="h-9 w-9 rounded-lg" />
          <span className="font-display text-xl font-extrabold">Qora</span>
        </Link>
        <div className="relative">
          <h2 className="font-display text-4xl font-extrabold leading-tight">Porta la tua attività online in pochi minuti.</h2>
          <p className="mt-4 text-white/70 text-lg">Pagina, menù digitale e QR dinamici, collegati tra loro.</p>
        </div>
        <p className="relative text-white/50 text-sm">© 2025 Qora</p>
      </div>

      <div className="flex items-center justify-center p-6">
        <form onSubmit={submit} className="w-full max-w-sm">
          <h1 className="font-display text-2xl font-extrabold">Crea il tuo account</h1>
          <p className="text-muted-foreground mt-1 mb-6">Gratis per iniziare, nessuna carta richiesta.</p>
          <div className="space-y-4">
            <div>
              <Label className="text-sm">Nome e cognome</Label>
              <Input value={form.name} onChange={(e) => set("name", e.target.value)} required className="h-11 mt-1.5" />
            </div>
            <div>
              <Label className="text-sm">Nome attività</Label>
              <Input value={form.company_name} onChange={(e) => set("company_name", e.target.value)} required className="h-11 mt-1.5" placeholder="Es. Trattoria Da Marco" />
            </div>
            <div>
              <Label className="text-sm">Email</Label>
              <Input type="email" value={form.email} onChange={(e) => set("email", e.target.value)} required className="h-11 mt-1.5" />
            </div>
            <div>
              <Label className="text-sm">Password</Label>
              <Input type="password" value={form.password} onChange={(e) => set("password", e.target.value)} required minLength={6} className="h-11 mt-1.5" />
            </div>
          </div>
          <Button type="submit" disabled={loading} className="w-full btn-grad text-white font-semibold h-11 mt-6">
            {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Crea account"}
          </Button>
          <p className="text-sm text-muted-foreground mt-5 text-center">
            Hai già un account? <Link to="/login" className="text-primary font-semibold">Accedi</Link>
          </p>
        </form>
      </div>
    </div>
  );
}
